function CustomConfigVO(logoBigUrl, logoSmallUrl, faviconUrl, browserTitleText, themeMainColor) {

    this.logoBigUrl = logoBigUrl;
    this.logoSmallUrl = logoSmallUrl;
    this.faviconUrl = faviconUrl;
    this.browserTitleText = browserTitleText;
    this.themeMainColor = themeMainColor;

    var _typeContext = {
    };

    this._getType = function(property) {
        if (_typeContext.hasOwnProperty(property)) {
            return _typeContext[property];
        }
        else {
            return undefined;
        }
    }
}
